import React from 'react';
import PropTypes from 'prop-types';
import './DeliveryMethodsAccordion.scss';

export const DeliveryMethodsAccordion = (props) => {
  const { id, extendClass = '', children } = props;
  const classes = ['panel-group', extendClass].join(' ');

  return (
    <div id={id} className={classes} role="tablist">
      {children}
    </div>
  );
};

DeliveryMethodsAccordion.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  extendClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
